import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import Modal from 'components/common/Modal/Modal'
import Button from 'components/common/Button/Button'
import style from './CoLabelPopup.module.scss'
import CoLabelSwitch from 'components/CoLabelSwitch/CoLabelSwitch'
import colors from 'styles/colors.scss'

const CoLabelPopup = () => {
  const { t } = useTranslation()
  const [ isOpen, setIsOpen ] = useState(true)

  const styles = {
    control:{
      border: '1px solid '+colors.colabelNeutralMid,
      '&:hover': {
        border: '1px solid '+colors.colabelNeutralMid
      },
    },
    option:{
      '&:hover': {
        backgroundColor: colors.colabelNeutralLight
      },
    },
    singleValue:{
      color: colors.olabelNeutralDark
    }
  }

  return (
    <Modal
      content={
        <>
          <h1 className={style.title}>{t('main:colabel.modal.title')}</h1>
          <p className={style.content}>{t('main:colabel.modal.content')}</p>
          <CoLabelSwitch
            displayName={true}
            className={style.select}
            styles={styles}
          />
          <Button
            label={t('main:colabel.modal.button')}
            className={style.button}
            onClick={() => setIsOpen(false)}
            type='primary'
          />
        </>
      }
      styles={{
        overlay:{
          backdropFilter: 'blur(8px)',
          background: 'rgba(18, 18, 23, .6)'
        },
        content:{
          maxWidth: '430px',
          overflow: 'visible',
          height: 'fit-content',
          padding: '32px'
        }
      }}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    />
  )
}

export default CoLabelPopup
